import POLICY_SCHEMA from '../metadata/policySchema.json';

export const PLUGIN_PROVIDERS = POLICY_SCHEMA.pluginProviders || [
  { value: 'presidio', label: 'Presidio', modes: ['redact', 'mask', 'block'] },
  { value: 'lakera', label: 'Lakera', modes: ['block', 'log'] }
];

export const APPROVAL_ROLE_PRESETS = POLICY_SCHEMA.approvalRolePresets || [
  { value: 'security-officer', label: 'Security officer' },
  { value: 'finance-manager', label: 'Finance manager' },
  { value: 'compliance-admin', label: 'Compliance admin' },
];

export function emptyPluginEntry(provider = 'presidio') {
  const def = PLUGIN_PROVIDERS.find((p) => p.value === provider) || PLUGIN_PROVIDERS[0];
  return { provider: def?.value || 'presidio', mode: def?.modes?.[0] || 'redact' };
}

export function normalizePluginsFormValue(plugins) {
  if (!plugins) return [];
  if (Array.isArray(plugins) && plugins.length && plugins[0]?.provider) {
    return plugins.map((p) => ({
      provider: p.provider || 'presidio',
      mode: p.mode || 'redact',
    }));
  }
  return [];
}

export function pluginsArrayFromEntries(entries) {
  const normalized = normalizePluginsFormValue(entries);
  return normalized.length ? normalized : undefined;
}

export function buildApprovalObject(approvalRole) {
  const role = String(approvalRole || '').trim();
  if (!role) return undefined;
  return { role };
}

export function approvalLabel(approvalRole) {
  const role = String(approvalRole || '').trim();
  if (!role) return null;
  const preset = APPROVAL_ROLE_PRESETS.find((p) => p.value === role);
  return preset?.label || role;
}

export function pluginsLabel(plugins) {
  const entries = normalizePluginsFormValue(plugins);
  if (!entries.length) return null;
  return entries.map((p) => `${p.provider} (${p.mode})`).join(', ');
}

export function modesForProvider(provider) {
  return PLUGIN_PROVIDERS.find((p) => p.value === provider)?.modes || ['redact'];
}
